import React, { Component } from "react";
import { Container, Row, Modal, ModalBody, ModalHeader } from "reactstrap";

import RequestManager from "../../singletons/RequestManager";

export default class OrderPlaceStore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      isLoadingProducts: false,
      showProductModal: false,
      selectedProduct: null,
      selectedSku: null
    };
  }

  componentDidMount() {
    this.productCategorySkuStock();
  }

  //Function to add items to cart
  addStockToCart = () => {};

  //Check if item has Multiple Sku
  _hasMultiSku = data => {
    if (data.stocks.length > 0) {
      return true;
    }
    return false;
  };

  _onSkuSelect = data => {};

  // check if item has any customization
  _hasCustomizations = () => {};

  _onProductCardClick = data => {
    if (this._hasMultiSku(data)) {
      this.setState({
        selectedProduct: data,
        showProductModal: true
      });
    } else {
      // add item to the cart
      this.setState({
        selectedProduct: true
      });
    }
  };

  _closeProductModal = () => {
    this.setState({
      showProductModal: false
    });
  };

  render() {
    const { products, showProductModal, selectedProduct } = this.state;
    return (
      <Container
        fluid
        style={{
          display: "flex",
          padding: 12,
          flexDirection: "row",
          height: "90vh",
          overflow: "hidden !important"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 6,
            overflowY: "auto"
          }}
        >
          {products.map(prod => {
            return (
              <Row
                key={prod.id}
                style={{
                  display: "flex",
                  alignContent: "center",
                  border: "1px solid black",
                  padding: 8
                }}
                onClick={() => this._onProductCardClick(prod)}
              >
                <div style={{ width: 70 }}>
                  <img
                    src={prod.image}
                    style={{ width: 60, objectFit: "contain" }}
                    alt=""
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <p>{prod.name}</p>
                  <p>INR {prod.stocks[0].salePrice}</p>
                  <p>{prod.categoryName}</p>
                  <p>{String(this._hasMultiSku(prod))}</p>
                </div>
              </Row>
            );
          })}
        </div>
        <div
          style={{
            display: "flex",
            flex: 2,
            border: "1px solid green",
            background: "green",
            overflowY: "auto"
          }}
        >
          <p style={{ color: "white", fontSize: 16 }}>Live Cart</p>
        </div>
        {selectedProduct && (
          <Modal
            style={{ height: "50vh", width: "70vw" }}
            isOpen={showProductModal}
          >
            <ModalHeader>
              <p>{selectedProduct.name}</p>
              <button onClick={this._closeProductModal}>Close</button>
            </ModalHeader>
            <ModalBody>
              {selectedProduct.stocks.map((stock, index) => (
                <div
                  style={{ height: 50, width: 50 }}
                  key={index}
                >{`${selectedProduct.name} ${index}`}</div>
              ))}
            </ModalBody>
          </Modal>
        )}
      </Container>
    );
  }

  _handleProductData = data => {
    let prodArr = {};
    data.forEach(element => {
      let ele = element.node;
      if (prodArr[ele.product] && prodArr[ele.product].stocks && ele.inStock) {
        let item = prodArr[ele.product];
        let stocks = item.stocks;
        stocks.push({
          stock: ele.stock,
          salePrice: ele.stockSalePrice,
          inStock: ele.inStock
        });
        item.stocks = stocks;
        prodArr[ele.product] = item;
      } else if (ele.inStock) {
        let item = {
          name: ele.productName,
          image: ele.productImage,
          id: ele.product,
          stocks: [],
          displayOrder: ele.productDisplayOrder,
          contains: ele.contains,
          category: ele.category,
          categoryName: ele.categoryName
        };
        item.stocks.push({
          stock: ele.stock,
          salePrice: ele.stockSalePrice,
          inStock: ele.inStock
        });
        prodArr[ele.product] = item;
      }
    });
    let prods = Object.values(prodArr);
    if (prods && prods.length > 0) {
      prods = prods.map(prod => {
        prod.stocks.sort((a, b) => a.salePrice - b.salePrice);
        return prod;
      });
      prods.sort((a, b) => a.displayOrder - b.displayOrder);
      console.log("Products sorted", prods);
      this.setState({
        products: prods,
        isLoadingProducts: false
      });
    } else {
      this.setState({
        products: [],
        isLoadingProducts: false
      });
    }
  };
  productCategorySkuStock = async () => {
    this.setState({
      isLoadingProducts: true
    });
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let storeId = storeInformation.store.id;
    let requestManager = new RequestManager();
    let params = {
      storeId: storeId
    };
    console.log("productCategorySkuStock", params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      "productCategorySkuStock",
      params
    );

    if (response.error === null) {
      console.log(
        "product>>>",
        JSON.stringify(response.data.productCategorySkuStock.edges)
      );
      this._handleProductData(response.data.productCategorySkuStock.edges);
    } else {
      alert("Something went wrong try again.");
      this.setState({
        isLoadingProducts: false
      });
      console.log("Connection to server failed.");
    }
  };

  getProducts = async productId => {
    this.setState({
      isLoadingProducts: true
    });

    let requestManager = new RequestManager();
    let params = {
      productId: productId
    };
    console.log("getProducts", params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getProducts",
      params
    );

    if (response.error === null) {
      console.log("getProducts>>>", JSON.stringify(response.data));
    } else {
      alert("Something went wrong try again.");
      this.setState({
        isLoadingProducts: false
      });
      console.log("Connection to server failed.");
    }
  };
}



// WEBPACK FOOTER //
// ./src/pages/OrderPlaceStore/OrderPlaceStore.js